import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';
import { OrderModel } from '../models/Customer Order model/order-model.model';


@Injectable({
  providedIn: 'root'
})
export class OrderService {
  private UsersOrder: OrderModel[] = [];
  
  // Create a BehaviorSubject to hold the current orders
  private ordersSubject = new BehaviorSubject<OrderModel[]>(this.UsersOrder);
  orders$ = this.ordersSubject.asObservable(); // Observable for components to subscribe to
  breakfastCoupon = false;
  
  constructor() { }

  addOrder(orderId: number, price: number) {
    const existingOrder = this.UsersOrder.find(u => u.itemId === orderId);
    if (existingOrder) {
      existingOrder.amount++; // Increase the amount if the order already exists
    } else {
      const newOrder: OrderModel = { itemId: orderId, amount: 1 , price: price };
      this.UsersOrder.push(newOrder); // Add a new order if it doesn't exist
    }
    
    this.ordersSubject.next(this.UsersOrder); // Emit the updated orders array
    //console.log('Users Order:', this.UsersOrder);
  }

  removeOrder(id: number) {
    this.UsersOrder = this.UsersOrder.filter(order => order.itemId !== id);
    this.ordersSubject.next(this.UsersOrder); // Emit the updated orders array
    //console.log('Users Order:', this.UsersOrder);
  }

  decreaseAmount(id: number) {
    const order = this.UsersOrder.find(u => u.itemId === id);
    if (order) {
      order.amount--;
      if (order.amount === 0) {
        this.removeOrder(id);
      } else {
        this.ordersSubject.next(this.UsersOrder); // Emit the updated orders array
      }
      //console.log('Users Order:', this.UsersOrder);
    } else {
      //console.error(`Order with id ${id} not found`);
    }
  }


  getAmount(id: number): number {
    const order = this.UsersOrder.find(u => u.itemId === id);
    return order ? order.amount : 0; // Return the amount or 0 if not found
  }


  getOrder(id: number): OrderModel | undefined {
    const order = this.UsersOrder.find(u => u.itemId === id);
    return order;
  }

  clearOrders(){
    this.UsersOrder = [];
    this.ordersSubject.next(this.UsersOrder); // Emit the updated, empty orders array
  }

  updateOrder(
    menuItemId: number,
    updatedValues: {
      price?: number;
      discountedPrice?: number;
      HasCoupon?: boolean;
      isCouponApplied?: boolean;
    }
  ): void {
    const order = this.UsersOrder.find(u => u.itemId === menuItemId);
    
    if (order) {
      // Update the order properties if they are provided
      if (updatedValues.price !== undefined) {
        order.price = updatedValues.price;
      }
      if (updatedValues.discountedPrice !== undefined) {
        order.discountedPrice = updatedValues.discountedPrice;
      }
      if (updatedValues.HasCoupon !== undefined) {
        order.HasCoupon = updatedValues.HasCoupon;
      }
      if (updatedValues.isCouponApplied !== undefined) {
        order.isCouponApplied = updatedValues.isCouponApplied;
      }
  
      // Emit the updated orders array
      this.ordersSubject.next(this.UsersOrder);
    } else {
      console.error(`Order with id ${menuItemId} not found`);
    }
  }
}
